<!--<app-sidenav [collapsed]="sideNavVisible$ | async"></app-sidenav>-->
<div class="content flex">
  <p class="govuk-body-l">Please check your company details and try again</p>
  <p><a href="javascript:;" (click)="goToSearch()">Search with a different organisation ID</a></p>
  <p><a href="https://www.crowncommercial.gov.uk/contact" target="_blank">Submit a conflict/claim form</a></p>
</div>
